import { Permissions } from '../../../../../core/common/permissions-enum';
import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { PermissionsPipe } from 'src/app/shared/pipes/permissions-pipe';
import { TeachersReportChartComponent } from '../../components/teachers-report-chart/teachers-report-chart.component';
import { StudentsReportChartComponent } from '../../components/students-report-chart/students-report-chart.component';
import { CurrentCallsReportChartComponent } from '../../components/current-calls-report-chart/current-calls-report-chart.component';
import { AppConsumptionChartComponent } from '../../components/app-consumption-chart/app-consumption-chart.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reports-charts',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TeachersReportChartComponent,
    StudentsReportChartComponent,
    CurrentCallsReportChartComponent,
    AppConsumptionChartComponent,
    PermissionsPipe,
  ],
  templateUrl: './reports-charts.component.html',
  styleUrls: ['./reports-charts.component.scss'],
})
export class ReportsChartsComponent extends BaseComponent implements OnInit {
  //constants
  Permissions = Permissions;

  constructor(injector: Injector) {
    super([], injector);
  }

  ngOnInit(): void {}
}
